/**
 * ============================ DEV FIXTURES ============================
 * Reine Entwicklungsdaten. KEINE echten Spiele, KEINE echten Trophaeen,
 * KEINE Guide-Inhalte. Bewusst neutral benannt, damit nichts davon je mit
 * echten Katalogdaten verwechselt wird.
 *
 * Diese Daten kommen niemals in eine Produktionsmigration.
 * =====================================================================
 */
export const DEV_FIXTURE_MARKER = 'DEV FIXTURE – keine echten Spieldaten';
const ids = {
    franchise: '00000000-0000-4000-8000-000000000001',
    gameA: '00000000-0000-4000-8000-000000000010',
    gameB: '00000000-0000-4000-8000-000000000011',
    gameC: '00000000-0000-4000-8000-000000000012',
    setA5: '00000000-0000-4000-8000-000000000020',
    setA4: '00000000-0000-4000-8000-000000000021',
    setB: '00000000-0000-4000-8000-000000000022',
    groupBase: '00000000-0000-4000-8000-000000000030',
    groupDlc: '00000000-0000-4000-8000-000000000031',
    schema: '00000000-0000-4000-8000-000000000040',
    sectionBase: '00000000-0000-4000-8000-000000000041',
    sectionDlc: '00000000-0000-4000-8000-000000000042',
    categoryBase: '00000000-0000-4000-8000-000000000043',
    categoryDlc: '00000000-0000-4000-8000-000000000044',
    roadmap: '00000000-0000-4000-8000-000000000050',
    phase1: '00000000-0000-4000-8000-000000000051',
    phase2: '00000000-0000-4000-8000-000000000052',
};
export const devFranchises = [
    {
        id: ids.franchise,
        name: 'Fixture Series',
        slug: 'fixture-series',
        popularityRank: 1,
        igdbId: null,
    },
];
export const devGames = [
    {
        id: ids.gameA,
        title: 'Fixture Game Alpha',
        slug: 'fixture-game-alpha',
        franchiseId: ids.franchise,
        coverUrl: null,
        releaseDate: null,
        publisher: null,
        developer: null,
        platforms: ['ps4', 'ps5'],
        supportState: 'full',
        igdbId: null,
    },
    {
        id: ids.gameB,
        title: 'Fixture Game Beta',
        slug: 'fixture-game-beta',
        franchiseId: ids.franchise,
        coverUrl: null,
        releaseDate: null,
        publisher: null,
        developer: null,
        platforms: ['ps5'],
        supportState: 'basic',
        igdbId: null,
    },
    {
        id: ids.gameC,
        title: 'Fixture Game Gamma',
        slug: 'fixture-game-gamma',
        franchiseId: null,
        coverUrl: null,
        releaseDate: null,
        publisher: null,
        developer: null,
        platforms: ['ps5'],
        supportState: 'catalog',
        igdbId: null,
    },
];
const emptyCount = { bronze: 0, silver: 0, gold: 0, platinum: 0, total: 0 };
/** Alpha hat zwei Sets (PS5 + PS4) – der Fall, der nie zusammengefuehrt wird. */
export const devTrophySets = [
    {
        id: ids.setA5,
        gameId: ids.gameA,
        npCommunicationId: 'NPWR-FIXTURE-A5',
        platform: 'ps5',
        region: 'global',
        version: '1.00',
        title: 'Fixture Game Alpha (PS5)',
        trophyTitleIconUrl: null,
        trophyCount: { ...emptyCount, bronze: 2, gold: 1, platinum: 1, total: 4 },
        hasPlatinum: true,
        supportState: 'full',
        psnLastSyncedAt: null,
    },
    {
        id: ids.setA4,
        gameId: ids.gameA,
        npCommunicationId: 'NPWR-FIXTURE-A4',
        platform: 'ps4',
        region: 'global',
        version: '1.00',
        title: 'Fixture Game Alpha (PS4)',
        trophyTitleIconUrl: null,
        trophyCount: { ...emptyCount, bronze: 2, gold: 1, platinum: 1, total: 4 },
        hasPlatinum: true,
        supportState: 'basic',
        psnLastSyncedAt: null,
    },
    {
        id: ids.setB,
        gameId: ids.gameB,
        npCommunicationId: 'NPWR-FIXTURE-B5',
        platform: 'ps5',
        region: 'global',
        version: '1.00',
        title: 'Fixture Game Beta (PS5)',
        trophyTitleIconUrl: null,
        trophyCount: { ...emptyCount, bronze: 3, total: 3 },
        hasPlatinum: false,
        supportState: 'basic',
        psnLastSyncedAt: null,
    },
];
export const devTrophyGroups = [
    {
        id: ids.groupBase,
        trophySetId: ids.setA5,
        psnGroupId: 'default',
        kind: 'base',
        name: 'Base Game',
        detail: null,
        iconUrl: null,
        order: 0,
        trophyCount: 3,
    },
    {
        id: ids.groupDlc,
        trophySetId: ids.setA5,
        psnGroupId: '001',
        kind: 'dlc',
        name: 'Fixture Add-on One',
        detail: null,
        iconUrl: null,
        order: 1,
        trophyCount: 1,
    },
];
function trophy(n, group, type) {
    return {
        id: `00000000-0000-4000-8000-0000000001${String(n).padStart(2, '0')}`,
        trophySetId: ids.setA5,
        trophyGroupId: group,
        order: n,
        psn: {
            psnTrophyId: n,
            name: `Fixture Trophy ${n}`,
            detail: 'Platzhaltertext aus den Dev-Fixtures.',
            type,
            iconUrl: null,
            hidden: false,
        },
        editorial: {
            tip: null,
            missable: false,
            pointOfNoReturn: false,
            customDisplayLogoUrl: null,
        },
    };
}
export const devTrophies = [
    trophy(0, ids.groupBase, 'bronze'),
    trophy(1, ids.groupBase, 'bronze'),
    trophy(2, ids.groupBase, 'gold'),
    trophy(3, ids.groupBase, 'platinum'),
    trophy(4, ids.groupDlc, 'bronze'),
];
export const devRoadmap = {
    id: ids.roadmap,
    gameId: ids.gameA,
    trophySetId: ids.setA5,
    title: 'Fixture Roadmap',
    currentPhaseId: ids.phase1,
    currentStepId: '00000000-0000-4000-8000-000000000060',
};
export const devRoadmapPhases = [
    { id: ids.phase1, roadmapId: ids.roadmap, title: 'Phase 1', order: 0 },
    { id: ids.phase2, roadmapId: ids.roadmap, title: 'Phase 2', order: 1 },
];
export const devRoadmapSteps = [
    {
        id: '00000000-0000-4000-8000-000000000060',
        phaseId: ids.phase1,
        title: 'Fixture Schritt 1',
        category: null,
        order: 0,
        shortInstruction: 'Platzhalter.',
        spoilerHint: null,
        pointOfNoReturn: false,
    },
    {
        id: '00000000-0000-4000-8000-000000000061',
        phaseId: ids.phase2,
        title: 'Fixture Schritt 2',
        category: null,
        order: 0,
        shortInstruction: 'Platzhalter.',
        spoilerHint: null,
        pointOfNoReturn: true,
    },
];
export const devRoadmapStepTrophies = [
    {
        roadmapStepId: '00000000-0000-4000-8000-000000000060',
        trophyId: devTrophies[0].id,
        relationType: 'primary',
    },
    {
        roadmapStepId: '00000000-0000-4000-8000-000000000060',
        trophyId: devTrophies[1].id,
        relationType: 'related',
    },
];
export const devCompletionSchema = {
    id: ids.schema,
    gameId: ids.gameA,
    trophySetId: ids.setA5,
};
export const devCompletionSections = [
    {
        id: ids.sectionBase,
        schemaId: ids.schema,
        trophyGroupId: null,
        title: 'Base Game',
        order: 0,
        kind: 'base',
    },
    {
        id: ids.sectionDlc,
        schemaId: ids.schema,
        trophyGroupId: ids.groupDlc,
        title: 'Fixture Add-on One',
        order: 1,
        kind: 'dlc',
    },
];
export const devCompletionCategories = [
    {
        id: ids.categoryBase,
        sectionId: ids.sectionBase,
        title: 'Sammelobjekte',
        order: 0,
    },
    {
        id: ids.categoryDlc,
        sectionId: ids.sectionDlc,
        title: 'Add-on Aufgaben',
        order: 0,
    },
];
export const devCompletionItems = [
    {
        id: '00000000-0000-4000-8000-000000000070',
        categoryId: ids.categoryBase,
        title: 'Fixture Sammelobjekte',
        order: 0,
        progressType: 'counter',
        target: 100,
        completionMode: 'manual',
        progressContributionType: 'proportional',
        weight: 2,
        missable: false,
    },
    {
        id: '00000000-0000-4000-8000-000000000071',
        categoryId: ids.categoryBase,
        title: 'Fixture Hauptaufgabe',
        order: 1,
        progressType: 'boolean',
        target: 1,
        completionMode: 'trophy',
        progressContributionType: 'binary',
        weight: 1,
        missable: false,
    },
    {
        id: '00000000-0000-4000-8000-000000000072',
        categoryId: ids.categoryDlc,
        title: 'Fixture Add-on Aufgabe',
        order: 0,
        progressType: 'boolean',
        target: 1,
        completionMode: 'manual',
        progressContributionType: 'binary',
        weight: 1,
        missable: false,
    },
];
//# sourceMappingURL=dev-fixtures.js.map